<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default  {
  name:  'App'
}
</script>
<style>
	.el-image{position: relative;}
	.el-image:after{content: ''; width: 100%; height: 100%; position: absolute; left: 0; top: 0;}
	.el-table__fixed-right-patch{background-color: #f8f8f9;}
	.el-table th.is-hidden.is-leaf{padding: 12px 0;}
	.el-timeline{margin: 0 10px;}
	.el-timeline-item__node--normal{left: -3px;}
	.el-timeline-item__tail{top: 3px; height: calc(100% - 3px); border-color: rgba(14, 116, 218, 0.1);}
	.el-timeline-item__node{
		width: 16px;
		height: 16px;
		background: rgba(14, 116, 218, 0.1);
		box-shadow: 0px 4px 12px 0px rgb(0 0 0 / 10%);
		border-radius: 50%;
		display: flex;
		align-items: center;
	}
	.el-timeline-item__node::after{
		content: '';
		width: 8px;
		height: 8px;
		background: rgba(14, 116, 218, 1);
		border-radius: 50%;
		box-shadow: 0px 4px 12px 0px rgb(0 0 0 / 10%);
	}
	.el-timeline-item{padding-bottom: 15px;}
	.timeline-date {
	    font-size: 15px;
	    color: #333;
	    font-weight: 500;
	    margin-bottom: 10px;
			padding-top: 2px;
			overflow: hidden;
	}
	.timeline-date .fr{color: #999;}
	
	.timeline-desc {
	    font-size: 14px;
			line-height: 18px;
	    color: #555;
	}
</style>
